import yup from '../yup';

export const emailVerificationSchema = yup.object().shape({
  email: yup.string()
    .nullable()
    .required('メールアドレスを入力してください')
    .label('email'),
});
